import connector from '../../connector/connector';
import RadarChart from '../../components/radarGraph/radarGraph';
import './sandbox.css';

const Sandbox = () => {
    // const fetchData = async () => {
    //     const maximums = await connector.getCategoryMaximums();
    //     console.log(maximums)
    // }
    // fetchData();
    // let newArray = new Array(5);
    // console.log(newArray.length)
    return (
        <>
    
        <RadarChart size={{width:500, height:600}} data={{"median": [
    {"axis": "Policy", "value": 11},
    {"axis": "People", "value": 15},
    {"axis": "Technology", "value": 21}
],"target": [
    {"axis": "Policy", "value": 32},
    {"axis": "People", "value": 31},
    {"axis": "Technology", "value": 41}
],"max": [
    {"axis": "Policy", "value": 32},
    {"axis": "People", "value": 31},
    {"axis": "Technology", "value": 41}
]}}></RadarChart>
        </>
    );
};

export default Sandbox;